import React from "react";
import PropTypes from "prop-types";
import { Stepper, Step, StepLabel, Typography } from "@mui/material";

function StepperNavigation({ steps, activeStep, isStepOptional, isStepSkipped, onStepClick }) {
  return (
    <Stepper activeStep={activeStep} sx={{ mb: 2 }}>
      {steps.map((label, index) => {
        const stepProps = {};
        const labelProps = {};
        if (isStepOptional(index)) {
          labelProps.optional = <Typography variant="caption">Opcional</Typography>;
        }
        if (isStepSkipped(index)) {
          stepProps.completed = false;
        }
        return (
          <Step
            key={label}
            {...stepProps}
            onClick={() => onStepClick(index)}
            style={{ cursor: "pointer" }}
          >
            <StepLabel
              {...labelProps}
              sx={{
                "& .MuiStepLabel-label": {
                  fontSize: "16px",
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
}

StepperNavigation.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeStep: PropTypes.number.isRequired,
  isStepOptional: PropTypes.func.isRequired,
  isStepSkipped: PropTypes.func.isRequired,
  onStepClick: PropTypes.func.isRequired,
};

export default StepperNavigation;
